<template>
  <li>
    <a :href="item.link" target="_blank">
      <div class="thumb">
        <img v-if="imgUrl" :src="imgUrl" alt="" width="90" />
      </div>
      <div class="detail">
        <p class="title">
          {{ item.title.rendered | truncateText(46) }}
        </p>
        <p class="date">{{ item.date | dateText('YYYY.MM.DD') }}</p>
      </div>
    </a>
  </li>
</template>

<script>
export default {
  props: ['item'],
  computed: {
    imgUrl() {
      const media = this.item._embedded['wp:featuredmedia'];
      if (media && media.length) {
        return media[0].source_url;
      }
      return null;
    }
  }
};
</script>
